import compass from "../../../../assets/story/chapters/chapter-01/characters/compass-standing-v1.png?url";
import ewer from "../../../../assets/story/characters/ewer-standing-v1.png?url";
import flint from "../../../../assets/story/chapters/chapter-01/characters/flint-standing-v1.png?url";
import frame from "../../../../assets/story/characters/frame-standing-v1.png?url";
import pin from "../../../../assets/story/characters/pin-standing-v1.png?url";
import projector from "../../../../assets/story/characters/projector-standing-v1.png?url";
import protagonist from "../../../../assets/story/characters/protagonist-hourglass-standing-v1.png?url";
import theater from "../../../../assets/story/backgrounds/dream-theater-window-v1.png?url";
import table from "../../../../assets/ui/battle-table-bg.jpg?url";
import titleLogo from "../../../../assets/ui/title-logo-tarot-v1.png?url";

export const MENU_ART = Object.freeze({
  compass,
  ewer,
  flint,
  frame,
  pin,
  protagonist,
  projector,
  theater,
  table,
  titleLogo,
});

const servantArt: Readonly<Record<string, string>> = {
  apprentice: protagonist,
  hourglass: protagonist,
  flint,
  ewer,
  projector,
  frame,
  pin,
  compass,
};

export function getMenuServantArt(servantId: string): string {
  return servantArt[servantId] ?? "";
}
